import { number } from 'prop-types';
import WarningIcon from 'Assets/icons/warning-blue.svg';
import useAuth from 'Hooks/useAuth';
import { useEffect } from 'react';
import useConsultationClinic from 'Containers/Teleconsult/hooks/useConsultationClinic';

import css from './AcceptedUnderInfo.less';

const AcceptedUnderInfo = ({ consultId }) => {
  const { accountId } = useAuth();
  const { consultationClinic, getConsultationClinic } = useConsultationClinic();

  useEffect(() => {
    if (!!accountId && !!consultId) {
      getConsultationClinic(accountId, consultId);
    }
  }, [accountId, consultId, getConsultationClinic]);

  if (!consultationClinic) return null;

  return (
    <div className={css.wrapper}>
      <img src={WarningIcon} alt="info" />
      <span>
        This request will be accepted under <strong>{consultationClinic.name}</strong>
      </span>
    </div>
  );
};

AcceptedUnderInfo.propTypes = {
  consultId: number.isRequired,
};

export default AcceptedUnderInfo;
